import React from 'react'

import {
  AlignItems,
  Box,
  Col,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Grid,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
  TextAlign,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type DiscountPerWeekProps = {
  campaignId: string
  campaignIdDiscountsMap: Record<string, string[]>
}

const RoundedBox = withCitrusTheme(Box, () => ({
  borderRadius: 5,
}))

export const DiscountPerWeek = ({ campaignId, campaignIdDiscountsMap }: DiscountPerWeekProps) => {
  const discountBoxes = [
    {
      discountText: 'OFF',
      label: '1st box',
      bgColor: Color.ColdGrey_500,
      textColor: Color.ColdGrey_200,
    },
    {
      discountText: 'OFF',
      label: '2nd box',
      bgColor: Color.Primary_600,
      textColor: Color.White,
    },
    {
      discountText: 'OFF',
      label: '3rd-8th box',
      bgColor: Color.ColdGrey_500,
      textColor: Color.White,
    },
  ]

  return (
    <Box data-testid="discount-per-week" display={Display.Flex}>
      <Grid columnGap={4} gridTemplateColumns="repeat(3, 1fr)">
        {discountBoxes.map((box, index) => (
          <Col key={box.label} size={1}>
            <Box
              display={Display.Flex}
              alignItems={AlignItems.Center}
              flexDirection={FlexDirection.Column}
              position={DisplayPosition.Relative}
            >
              {index === 0 && (
                <Box
                  position={DisplayPosition.Absolute}
                  top="-16px"
                  left="50%"
                  style={{ transform: 'translateX(-50%)', zIndex: 1 }}
                >
                  <Box position={DisplayPosition.Relative}>
                    <Box position={DisplayPosition.Relative} style={{ zIndex: 1 }}>
                      <Icon name="success" variant={IconVariant.Confirmation} size={6} />
                    </Box>
                    <Box
                      position={DisplayPosition.Absolute}
                      top="46.5%"
                      left="51%"
                      style={{ transform: 'translate(-50%, -50%)', zIndex: 0 }}
                    >
                      <Icon
                        name="tick"
                        variant={IconVariant.Inherit}
                        color={Color.White}
                        size={5}
                      />
                    </Box>
                  </Box>
                </Box>
              )}
              <RoundedBox
                bg={box.bgColor}
                borderRadius={1.5}
                display={Display.Flex}
                alignItems={AlignItems.Center}
                justifyContent={JustifyContent.Center}
                flexDirection={FlexDirection.Column}
                paddingV={2}
                paddingH={[4, 2]}
                width="100%"
              >
                <Text
                  size={5}
                  color={box.textColor}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                  style={index === 0 ? { textDecoration: 'line-through' } : {}}
                >
                  {campaignIdDiscountsMap[campaignId][index]}
                </Text>
                <Text
                  size={5}
                  color={box.textColor}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                  style={index === 0 ? { textDecoration: 'line-through' } : {}}
                >
                  {box.discountText}
                </Text>
                <Text
                  size={2}
                  color={box.textColor}
                  textAlign={TextAlign.Center}
                  style={
                    index === 0
                      ? { textDecoration: 'line-through', whiteSpace: 'nowrap' }
                      : { whiteSpace: 'nowrap' }
                  }
                >
                  {box.label}
                </Text>
              </RoundedBox>
            </Box>
          </Col>
        ))}
      </Grid>
    </Box>
  )
}
